import React from 'react'

const PendingCard = ({ firstData, firstTitle, className = 'pending' }) => {
    return (
        <div className={`${className || ''}`}>
            <div className="c-pending" style={{flex: 1}}>
                <div className='c-pending-content' style={{flexDirection: 'column', alignItems: 'center', height: '100%', justifyContent: 'center'}}>
                    <div className='chart-title'>
                        <p>{firstTitle}</p>
                    </div>
                    <div className='pending-value'>
                        <p>{firstData}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PendingCard